import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref } from "vue"

const _hoisted_1 = { class: "text-large font-600 mr-3" }
const _hoisted_2 = {
  style: {"margin-top":"20px"},
  "element-loading-text": "正在获取用户数据，请稍后"
}

import { ref, unref, nextTick, reactive } from 'vue';
import { useRouter } from 'vue-router'

/* Npm Plguins */
import { ElMessage } from 'element-plus';

/* Utils & Helpers */
import { propTypes } from '@/utils/propTypes'
import { findIndex } from '../../../utils/index'
import { GetPartType } from '../../../helpers/statusHelpers'

import ContractForm from '../forms/ContractsForms.vue'
import PayPlanCmp from './2_PayPlan.vue'
import Progress from './4_progress.vue'

import Material from '@/components/plugins/materials/Index.vue'

/* Apis */
import { GetContractApi, GetCtNumberApi, GetByWorkIdApi } from '../../../apis/contract/contract.api'
import { GetDeptAuditMenbersApi } from '@/apis/basics/rules/apis'

/* Types */
import type { PayPlanList } from '../../../apis/PayPlans/payplan.type'
import { GetAuditMembersApi } from '../../../apis/ct_categorys_config/categorycfg.api';


export default /*#__PURE__*/_defineComponent({
  props: {
    titles: propTypes.string.def(''),
    showprogress: propTypes.bool.def(false),
    isPreview: propTypes.bool.def(false),
    isEditor: propTypes.bool.def(false),
    showUpload: propTypes.bool.def(true),
},
  emits: ["checkAudit", 'onSuccess'],
  setup(__props, { expose, emit: $emit }) {

const props = __props



const { go } = useRouter()



const disabledPlan = ref<boolean>(false)

const ctFormRef = ref<ComponentRef<typeof ContractForm>>()
const payPlanRef = ref<ComponentRef<typeof PayPlanCmp>>()
const progressRef = ref<ComponentRef<typeof Progress>>()

const metarialRef = ref<ComponentRef<typeof Material>>()

const activeTag = ref<string>('1st')
const loading = ref<boolean>(false)
const showProgress = ref<boolean>(false)

const contract = ref<any>()

/* 获取设置的币种 */
const onCurrencyUpdate = (cy: any) => {
    unref(ctFormRef)?.methods.setCurrency(cy)
}

/* 设置Tag表情项 */
const setActiveTag = (tagId: string) => {
    activeTag.value = tagId
}

/* 获取合同明细 */
const getContractDetail = (contractId: string) => {

    loading.value = true

    GetContractApi(contractId).then(res => {

        if (!res.succeeded) {
            ElMessage.error(`读取合同信息出错，可能的原因是：${res.errors}`)
        }
        else {

            const data = res.data

            showProgress.value = data.status != '1' && props.showprogress  // 是否显示审批进度
            data.apply_User = `${data.create_user_name}(${data.created_user_id})`

            /* 设置相对方记录 */
            const customer = data.counterpartList[0]

            if (customer) {
                data.counterpartList = [{
                    counterpart_id: customer.id,
                    counterpart_name: customer.name,
                    counterpart_address: customer.address,
                    counterpart_contract: customer.contract,
                    counterpart_contract_num: customer.contract_num,
                    category_name: GetPartType(customer.part_type_id).text,
                    code: customer.no
                }]
            }

            disabledPlan.value = (data.amount_flag || 'N') == 'N' ? true : false

            var approve = data.is_approve == 'Y' && data.status == "2"

            $emit("checkAudit", { approve, data })
            $emit('onSuccess', data)

            contract.value = data

            /* 遇事不决，NextTick */
            nextTick(() => {
                unref(ctFormRef)?.methods.setFormData(data) // 基本信息表单
                unref(payPlanRef)?.methods.setDatas(data)   // 付款信息
                unref(metarialRef)?.func.getData(data.id, data.code)   // 合同附件
                unref(progressRef)?.methods.setContractId(data.id, data.created_user_id)    // 审批流程
            })

        }

    }).finally(() => { loading.value = false })

}

/* 获取合同明细（工作流ID） */
const getContractDetailByWorkId = (workId: string) => {

    loading.value = true

    GetByWorkIdApi(workId).then(res => {

        if (!res.succeeded) {
            ElMessage.error(`读取合同信息出错，可能的原因是：${res.errors}`)
        }
        else {

            const data = res.data

            showProgress.value = data.status != '1' && props.showprogress  // 是否显示审批进度

            /* 设置相对方记录 */
            const customer = data.counterpartList[0]

            if (customer) {

                data.counterpartList = [{
                    counterpart_id: customer.id,
                    counterpart_name: customer.name,
                    counterpart_address: customer.address,
                    counterpart_contract: customer.contract,
                    counterpart_contract_num: customer.contract_num,
                    category_name: GetPartType(customer.part_type_id).text,
                    code: customer.no
                }]

            }

            disabledPlan.value = (data.amount_flag || 'N') == 'N' ? true : false

            var approve = data.is_approve == 'Y' && data.status == 2

            contract.value = data

            $emit("checkAudit", { approve, data })
            $emit('onSuccess', data)

            /* 遇事不决，NextTick */
            nextTick(() => {
                unref(ctFormRef)?.methods.setFormData(data) // 基本信息表单
                unref(payPlanRef)?.methods.setDatas(data)   // 付款信息
                unref(metarialRef)?.func.getData(data.id, data.code)   // 合同他附件 V2
                unref(progressRef)?.methods.setContractId(data.id, data.created_user_id)    // 审批流程
            })
        }

    }).finally(() => { loading.value = false })

}


/* 获取合同编号 */
const getCtNumber = () => {

    GetCtNumberApi().then(res => {

        if (!res.succeeded) {
            ElMessage.warning(`获取合同号失败，可能的原因是：${res.errors}`)
        }
        else {
            unref(ctFormRef)?.methods.setContractNum(res.data);
            unref(metarialRef)?.func.getData('', res.data)
        }

    }).finally(() => { });

};

/* 对外的方法 */
const methods = {
    checkFromData: async () => {

        const formRef = unref(ctFormRef)
        const planRef = unref(payPlanRef)

        try {
            let savedata: any = formRef?.methods.getFormData()

            await formRef?.elFormRef?.validate();

            /* 如何金额类型为确定，则需要检查付款计划配置 */
            if (savedata.amount_flag == 'Y') {
                /* 付款计划 */
                const payPlanSchema = planRef?.schema
                if (!payPlanSchema || (payPlanSchema?.contract_amount || 0) <= 0 || (payPlanSchema?.plan_list.length || 0) <= 0) {
                    setActiveTag('3rd')
                    ElMessage.warning("请检查“付款信息”栏，付款计划是否未设置或设置异常。")
                    return false;
                }
            }

            return true

        } catch (err) {
            ElMessage.warning(`合同基础资料未完善`)
            setActiveTag('1st');
            return false;
        }
    },

    /* 获取保存的数据 */
    getFormData: () => {

        const formRef = unref(ctFormRef)
        const planRef = unref(payPlanRef)
        const filesRef = unref(metarialRef)

        try {

            let savedata: any = formRef?.methods.getFormData()

            /* 付款计划 */
            const payPlanSchema = planRef?.schema

            savedata.currency = payPlanSchema?.currency
            savedata.payment = payPlanSchema?.payment

            payPlanSchema?.plan_list.forEach((item: any) => {

                const rowIndex = findIndex<PayPlanList>(payPlanSchema?.plan_list, (t: any) => { return t.id == item.id })

                item.sort = rowIndex
                item.id = null
                item.contract_id = null
                item.tenant_id = '1'

            });

            /* 附件数据 */
            const fileList = filesRef?.func.getFilesIds()
            savedata = Object.assign(savedata, { files: fileList, payplanList: payPlanSchema?.plan_list });
            return savedata;

        } catch (err) {
            ElMessage.warning(`合同基础资料未完善`)
            setActiveTag('1st');
        }
    },

    /* 设置表单数据 */
    setFormData: (dataId: string) => {
        getContractDetail(dataId)
    },

    /* 通过WorkId获取合同详细 */
    setFormDataByWorkId: (workId: string) => {
        getContractDetailByWorkId(workId)
    },

    /* 生成合同编号 */
    setContractNum: () => {
        getCtNumber()
    },

    setDpetAuditUsers: async () => {
        unref(ctFormRef)?.methods.setUserLoad(true)

        const schema = unref(ctFormRef)?.methods.getFormData()

        const deptRes = await GetDeptAuditMenbersApi()
        schema!.emp_audit_list = deptRes.data || []

        unref(ctFormRef)?.methods.setUserLoad(false)
    }

}

const onAmtFlagChange = (flag: any) => {

    disabledPlan.value = (flag.amount_flag || 'N') == 'N' ? true : false

    if (flag.amount_flag || 'N') {
        unref(payPlanRef)?.methods.clearData()
    }

}

/* 一些数据更新事件 */
const events = {
    onCategoryChange: () => {
        getAuditMembers()
    },
    onMainstayChange: () => {
        getAuditMembers()
    },
    onAmountUpdate: (amount: any) => {
        unref(ctFormRef)?.methods.setAmounts(amount)
        getAuditMembers()
    }
}

const getAuditMembers = async () => {


    const schema = unref(ctFormRef)?.methods.getFormData()

    const amounts = schema?.contract_amount || 0
    const categoryId = schema?.category_id
    const mainstayId = schema?.mainstay_id

    if (categoryId && mainstayId) {

        unref(ctFormRef)?.methods.setUserLoad(true)

        /* 使用人确认 */
        // const userRes = await GetAuditMembersApi({ category_id: categoryId, mainstay_id: mainstayId, amount: amounts || 0, node_id: "19903" });
        // schema.emp_used_list = userRes.data || []

        /* 会签 */
        const signRes = await GetAuditMembersApi({ category_id: categoryId, mainstay_id: mainstayId, amount: amounts || 0, node_id: "19904" });
        schema.emp_sign_list = signRes.data || []

        const node09Res = await GetAuditMembersApi({ category_id: categoryId, mainstay_id: mainstayId, amount: amounts || 0, node_id: "19909" });
        schema.second_list = node09Res.data || []

        const node10Res = await GetAuditMembersApi({ category_id: categoryId, mainstay_id: mainstayId, amount: amounts || 0, node_id: "19910" });
        schema.president_list = node10Res.data || []

        const node11Res = await GetAuditMembersApi({ category_id: categoryId, mainstay_id: mainstayId, amount: amounts || 0, node_id: "19911" });
        schema.chairman_list = node11Res.data || []

        unref(ctFormRef)?.methods.setUserLoad(false)

    }
}

expose({ methods })

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_page_header, {
        onBack: _cache[1] || (_cache[1] = ($event: any) => (_unref(go)(-1)))
      }, {
        content: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(__props.titles), 1)
        ]),
        extra: _withCtx(() => [
          _renderSlot(_ctx.$slots, "Options")
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_tabs, {
              type: "border-card",
              modelValue: activeTag.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTag).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  name: "1st",
                  label: "合同基本信息",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(ContractForm, {
                      ref_key: "ctFormRef",
                      ref: ctFormRef,
                      "is-preview": props.isPreview,
                      "is-editor": props.isEditor,
                      onCategoryChange: events.onCategoryChange,
                      onMainstayChange: events.onMainstayChange,
                      onOnAmountFlagChange: onAmtFlagChange
                    }, null, 8, ["is-preview", "is-editor", "onCategoryChange", "onMainstayChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  name: "3rd",
                  label: "付款信息",
                  disabled: disabledPlan.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(PayPlanCmp, {
                      ref_key: "payPlanRef",
                      ref: payPlanRef,
                      "is-previews": props.isPreview,
                      onUpdate: events.onAmountUpdate,
                      "onUpdate:currency": onCurrencyUpdate
                    }, null, 8, ["is-previews", "onUpdate"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_tab_pane, {
                  name: "4th",
                  label: "合同附件"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Material, {
                      ref_key: "metarialRef",
                      ref: metarialRef,
                      "is-preview": props.isPreview,
                      "show-upload": props.showUpload
                    }, null, 8, ["is-preview", "show-upload"])
                  ]),
                  _: 1
                }),
                (showProgress.value)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 0,
                      name: "5rf",
                      label: "审核进度"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Progress, {
                          ref_key: "progressRef",
                          ref: progressRef
                        }, null, 512)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])), [
            [_directive_loading, loading.value]
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})